import React from 'react'
import styled from 'styled-components'
import { Card } from '@pancakeswap-libs/uikit'

export const BodyWrapper = styled.div`
  position: relative;
  max-width: 436px;
  width: 100%;
  z-index: 5;
  background-color: !important;
  
// border: 40px solid transparent;
// border-image:url('/images/16.png') 70 stretch;
`

/**
 * The styled container element that wraps the content of most pages and the tabs.
 */
export default function AppBody({ children }: { children: React.ReactNode }) {
  return <BodyWrapper style={{backgroundImage:`${localStorage.getItem("IS_DARK") === "false"?"url(/images/Block1.png)":"url(/images/dark.png)"}`,backgroundSize:"100% 100%",padding:"50px"}}>{children}</BodyWrapper>
}
